import styled from 'styled-components';
import { rem } from 'polished';

interface IStyledProcesses {
  theme: any;
}

export const StyledProcesses = styled.div<IStyledProcesses>`
  .main-title {
    font-size: 3em;
    ${(props) => props.theme.breakpoints.phone`
      font-size: 4em;
    `}
  }
  .mobile-main {
    padding: ${rem(`16px`)} ${rem(`16px`)} 0;
  }
  .mobile-content-welcome h2 {
    line-height: 3.5rem;
    word-break: break-all;
    ${({ theme }) => theme.breakpoints.phablet`
      word-break: initial;
    `}
  }
  .back-button {
    margin-top: ${rem(`48px`)};
  }
`;
